// extracted by mini-css-extract-plugin
module.exports = {"screen":"TicketNotAuthorized-screen","container":"TicketNotAuthorized-container","text":"TicketNotAuthorized-text","image":"TicketNotAuthorized-image"};